export default {
  form: {
    address: {
      label: 'Adresă',
      placeholder: 'Stradă + număr',
    },
    city: {
      label: 'Oraș',
      placeholder: 'Oraș',
    },
    state: {
      label: 'Județ/Stat',
      placeholder: 'Selectați județul/statul',
    },
    country: {
      label: 'Țară',
      placeholder: 'Selectați țara',
    },
    zip_code: {
      label: 'Cod poștal',
      placeholder: 'Cod poștal',
    },
  },
};
